///////////////////////////////////////////////////
// Manage all signlr hubs which the client consumes
///////////////////////////////////////////////////

import EventBus from '../EventBus';
import {
  HubConnectionBuilder,
  HttpTransportType,
  LogLevel,
} from '@aspnet/signalr';
import SignalrConfig from '../../configs/SignalrConfig';
import authProvider from '../AuthenticationProvider';
import connector from '../Connector';
import { formatMessageData } from './helper';
import { ChanelConfig } from './../../configs/GlobalConfig';

class SignalrMessageHub extends EventBus {
  messageChanelToHubs = []; // map hubs to a label
  remoteChanelToHubs = []; // rpc
  queuedRemoteCalls = []; // if a rpc posted while connection down, push it to a queue
  runQueueThread = null;

  constructor() {
    super();
    this.init();
  }
  count = 0;
  // iterate all signalr config and create connections
  init() {
    // SignalrConfig.Hubs.forEach((hub, index) => {
    //   const connection = new HubConnectionBuilder()
    //     .withUrl(hub.ServerUrl, {
    //       transport: HttpTransportType.WebSockets, //HttpTransportType.LongPolling, // | HttpTransportType.WebSockets // websocket will throw error, can not resolve this yet
    //       accessTokenFactory: () =>
    //         authProvider
    //           .getUser()
    //           .then(user => (user == null ? '' : user.access_token)),
    //       skipNegotiation: true,
    //     })
    //     .configureLogging(LogLevel.Error)
    //     .build();
    //   //map hub connection to a label
    //   this.messageChanelToHubs[hub.Prefix] = connection;
    //   connection.on('ReceiveMessage', message => {
    //     // console.log(message);
    //     // special process for tick data
    //     // if (message.chanel === ChanelConfig.TickChanel) {
    //     //   message.data.forEach(ticker => {
    //     //     this.publish(ChanelConfig.TickChanel + '.' + ticker.ticker, ticker);
    //     //   });
    //     // } else {\
    //     // console.log(message)
    //     this.publish(
    //       message.chanel,
    //       this.preprocessData(message.chanel, message.data),
    //     );
    //     // }
    //   });
    //   //do reconnect
    //   connection.onclose(e => setTimeout(() => this.connect(connection), 5000));
    //   this.connect(connection);
    //   //register rpc, map a rpc to a hub
    //   hub.RegisteredRemoteChanels.forEach((chanel, index) => {
    //     if (this.remoteChanelToHubs[chanel]) {
    //       throw new Error('Remote chanel is duplicated: ' + chanel);
    //     }
    //     this.remoteChanelToHubs[chanel] = connection;
    //   });
    // });
  }

  async connect(hub) {
    let self = this;
    await hub
      .start()
      .then(() => self.runQueue())
      .catch(err => {
        console.log(err);
        //try re-connecting after 5s
        setTimeout(() => {
          // console.log('reconnect');
          this.connect(hub);
        }, 5000);
      });
  }

  //push an action to the queue
  //it is posible for a race condition
  ensure(f) {
    this.queuedRemoteCalls.push(f);
  }

  runQueue() {
    var fails = [];
    while (this.queuedRemoteCalls && this.queuedRemoteCalls.length > 0) {
      var f = this.queuedRemoteCalls.shift();
      if (!f()) {
        fails.push(f);
      }
    }
    for (var f of fails) {
      this.queuedRemoteCalls.push(f);
    }
    if (this.runQueueThread != null) {
      clearTimeout(this.runQueueThread);
    }
    this.runQueueThread = setTimeout(() => {
      this.runQueue();
    }, 1000);
  }

  invoke(chanel, message, fail) {
    this.remoteChanelToHubs[chanel]
      .invoke(chanel, message)
      .catch(error => fail(error));
  }

  subscribe(chanel, action) {
    var me = this;
    if (!this.chanels[chanel]) {
      this.chanels[chanel] = [];
    }

    connector.subscribe(chanel, function(message) {
      me.publish(message.chanel, message.data);
    });

    if (action) {
      this.chanels[chanel].push(action);
    }
  }

  unsubscribe(chanel, action) {
    if (this.chanels[chanel]) {
      this.chanels[chanel] = this.chanels[chanel].filter(a => a !== action);

      if (this.chanels[chanel].length === 0) {
        delete this.chanels[chanel];
      }
    }
  }

  preprocessData(chanel, data) {
    if (chanel.indexOf(ChanelConfig.HeatMapChanelPrefix) >= 0) {
      for (var sector of data.sectors) {
        if (sector && sector.tickers) {
          for (var ticker of sector.tickers) {
            this.subscribe(ChanelConfig.TickChanel + '.' + ticker.organCode);
          }
        }
      }
    }

    return formatMessageData(chanel, data);
  }
}

const MessageHub = new SignalrMessageHub();

export default MessageHub;
